import { API, API_GET_ID } from "../../../Config";

export const GetSingleDiet = (id) => {
  return API_GET_ID(API.SingleDiet, id);
};
